// assets/quickview-unselected.js
(function () {
  function getIdInput(root) {
    // 「buttonsフォーム」内の hidden id だけを見る
    return root.querySelector('form.js-prod-form-submit input[name="id"]');
  }

  function getSelectedVariantId(root) {
    const el = getIdInput(root);
    const v = el && el.value ? String(el.value).trim() : '';
    return v || '';
  }

  function setUI(root, enabled) {
    const priceWrap = root.querySelector('.c-qv-price');
    const btn = root.querySelector('#addToCart');

    if (!enabled) {
      if (priceWrap) priceWrap.classList.add('is-hidden');
      if (btn) btn.disabled = true; // 未選択の時だけ確実に止める
      return;
    }

    // 選択済みなら価格は出す
    if (priceWrap) priceWrap.classList.remove('is-hidden');

  }

  function initQuickview(root) {
    if (!root || root.__qvInit) return;
    root.__qvInit = true;

    function refresh() {
      const variantId = getSelectedVariantId(root);

      if (!variantId) {
        root.dataset.unselected = 'true';
        setUI(root, false);
        return;
      }

      root.dataset.unselected = 'false';
      setUI(root, true);
    }

    // 送信ブロック（未選択 or ボタンがdisabled＝SOLDOUT等）
    root.addEventListener(
      'submit',
      function (e) {
        const variantId = getSelectedVariantId(root);
        const btn = root.querySelector('#addToCart');

        if (!variantId || (btn && btn.disabled)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      },
      true
    );

    // swatch / select / click どっちでも拾う
    root.addEventListener('change', () => setTimeout(refresh, 0));
    root.addEventListener('click',  () => setTimeout(refresh, 0));

    refresh();
  }

  function boot() {
    document.querySelectorAll('.js-quickview-wrapper').forEach(initQuickview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Quickviewは後からDOMに入るので監視
  const observer = new MutationObserver(boot);
  observer.observe(document.body, { childList: true, subtree: true });
})();
